var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product-item" },
    [
      _c(
        "router-link",
        { staticClass: "image-container", attrs: { to: _vm.path, tag: "a" } },
        [
          _c("div", { staticClass: "content-layer" }, [
            _c("div", { staticClass: "product-tags" }, [
              _vm.item.award_winner
                ? _c("div", { staticClass: "special-tag" }, [
                    _c("div", { staticClass: "tag-content" }, [
                      _vm._v("\n            Award Winner\n          "),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.lowStock(_vm.item.id)
                ? _c("div", { staticClass: "low-stock-tag" }, [
                    _c("div", { staticClass: "tag-content" }, [
                      _vm._v("\n            Low Stock\n          "),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.outOfStock(_vm.item.id)
                ? _c("div", { staticClass: "out-of-stock-tag" }, [
                    _c("div", { staticClass: "tag-content" }, [
                      _vm._v("\n            Out of Stock\n          "),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "product-teaser-quick-view-container hidden-sm hidden-xs",
              },
              [
                _c(
                  "b-button",
                  { staticClass: "quick-view", attrs: { title: "Quickview" } },
                  [
                    _c("span", [
                      _vm._v("\n            View product\n          "),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("AImage", {
            attrs: {
              img: _vm.item.image,
              preset: "wineproductteaser",
              contain: "",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "description-container" }, [
        _c(
          "h3",
          { staticClass: "product-name" },
          [
            _c("router-link", { attrs: { to: _vm.path, tag: "a" } }, [
              _vm._v("\n        " + _vm._s(_vm.item.title) + "\n      "),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "product-price-container" }, [
          _c(
            "div",
            { staticClass: "price" },
            [
              _c("ecommerce-product-price", {
                attrs: { item: _vm.priceCalcItem, showrrprice: false },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }